/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * An external member: someone on the team who isn't an Arbi user.
 */
export interface CreateNetworkMemberRequest {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  email?: string | null;
  linkedin_url?: string | null;
}
